module.exports = __webpack_public_path__ + "461ab670eb7339dfab8aabc6d0d2ca79.png";